import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6c7b3d14"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode(" ユーザー名はコンテスト参加時などに表示されます。すべての人に公開されるため、個人が特定されないユーザー名を設定してください。半角および全角の文字が使用可能です。")
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" プライバシーポリシー ")
const _hoisted_3 = /*#__PURE__*/_createTextVNode(". ")
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("input", {
  class: "autocomplete-hide",
  type: "email",
  name: "autocompletehide1"
}, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("input", {
  class: "autocomplete-hide",
  type: "text",
  name: "autocompletehide2"
}, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("input", {
  class: "autocomplete-hide",
  type: "password",
  name: "autocompletehide3"
}, null, -1))
const _hoisted_7 = { class: "form-item-agreement" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" 13才以上です。. ")
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "required" }, "*", -1))
const _hoisted_10 = { class: "form-item-agreement" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" 規約に同意します。弊社の ")
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" 利用規約 ")
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" 及び ")
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" プライバシーポリシー ")
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" をご覧ください。. ")
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "required" }, "*", -1))
const _hoisted_17 = { class: "form-item-agreement" }
const _hoisted_18 = /*#__PURE__*/_createTextVNode(" テラサイクルの最新情報を受け取ります! ")

import { reactive, ref, computed, onMounted } from 'vue';
  import { ColorVariants, GENDER_MAP } from '@/constants';
  import _ from 'lodash';
  import { useI18n } from 'vue-i18n';
  import { settingStore, authStore } from '@/stores';
  import { Country, getCountryCodeByPhoneNumber } from '@/components/country-selector/countries';
  import { useRoute } from 'vue-router';
  import { IAddressAutocompleteData } from '@/components/address-autocomplete/type';
  import { Validator, alert } from '@/utils';

  interface IForm {
    email: string;
    phone_number: string; // 注册时phone_number在外面
    password: string;
    password_confirmation: string;
    // rucaptcha: string;
    subscribe_tc_information: boolean;
    signup_condictions: Array<string>;
    profile_attributes: Partial<{
      gender: 'unknown' | 'male' | 'female',
      first_name: string;
      last_name: string;
      nick_name: string;
      age: string;
      street_address: string;
      extended_address: string;
      locality: string;
      region: string;
      postal_code: string;
      organization_name: string;
      organization_type: string;
      people_collection: number;
      source_channel: string;
      phone_number: string; // 编辑时phone_number在里面
    }>
  }

  interface IEmits {
    (event: 'submit', data: Partial<IForm>): void;
  }

  
export default /*#__PURE__*/_defineComponent({
  emits: ["submit"],
  setup(__props, { emit: emits }: { emit: ({
    (event: 'submit', data: Partial<IForm>): void;
  }), expose: any, slots: any, attrs: any }) {

  
  const route = useRoute();
  const postalCode = ref();
  const isSignup = route.name === 'signup';
  const agreeCheckbox = reactive({
    agree1: false,
    agree2: false,
  });
  const signupCondictions = reactive<Array<string | false>>([]);
  const { t, locale } = useI18n();
  const phoneNumberDialCode = ref<number | undefined>();
  const contryCode = ref<string | undefined>(locale.value);

  const form = reactive<Partial<IForm>>({ profile_attributes: {} });

  const phoneNumber = computed(() => {
    if (form.phone_number) {
      return String(form.phone_number).startsWith('+') ? form.phone_number : `+${phoneNumberDialCode.value} ${form.phone_number}`;
    }
    return '';
  });

  const signupAdditionalAgreements = computed<string[]>(() => {
    const arr = [];
    if (_.get(settingStore, 'data.sign_up_form_additional_checkbox1.is_show')) {
      arr.push(settingStore.data?.sign_up_form_additional_checkbox1?.content || '');
    }
    if (_.get(settingStore, 'data.sign_up_form_additional_checkbox2.is_show')) {
      arr.push(settingStore.data?.sign_up_form_additional_checkbox2?.content || '');
    }
    return arr;
  });

  function handleFormItemChange(data: any) {
    _.set(form, data.key, data.value);
  }

  function handleSubmit() {
    const { phone_number, profile_attributes, password, password_confirmation } = form;
    if (phone_number) {
      const isValid = Validator.isPhoneNumberValid(phone_number as string);
      if (!isValid) {
        alert({ title: t('phoneNumberIsInValid') });
        return;
      }
    }
    if (password !== password_confirmation) {
      alert({ title: t('Inconsistent password input') });
      return;
    }
    if (profile_attributes?.postal_code) {
      const isValid = /^[0-9]*$/.test(String(profile_attributes.postal_code));
      if (!isValid) {
        alert({ title: '郵便番号 - ハイフンなし、半角英数字で入力してください。' });
        return;
      }
    }
    const body = {
      ...form,
      phone_number: phoneNumber.value
    };
    if (isSignup) {
      body.signup_condictions = signupCondictions.filter(Boolean) as string[];
    } else {
      _.set(body, 'profile_attributes.phone_number', phoneNumber.value);
    }
    emits('submit', body);
  }

  function handleGetPhoneNumberCountry(country: Country) {
    phoneNumberDialCode.value = country.dialCode;
    contryCode.value = country.code;
  }

  function handleGetAddress(addressInfo: IAddressAutocompleteData) {
    Object.assign(form.profile_attributes, addressInfo);
  }

  function handleAddressChange(data: any) {
    postalCode.value = data;
  }

  onMounted(async () => {
    settingStore.tryFetchData();
    if (!isSignup) {
      await authStore.tryFetchData();
      const profile = authStore.user.profile;
      Object.assign(form.profile_attributes, profile);
      form.phone_number = authStore.phoneNumber;
      contryCode.value = getCountryCodeByPhoneNumber(_.get(profile, 'phone_number'));
    }
  });

  const ageOptions = computed(() => {
    const ages = [
      { text: '13-15', value: '13-15' },
      { text: '16-18', value: '16-18' },
      { text: '19-25', value: '19-25' },
      { text: '26-35', value: '26-35' },
      { text: '36-50', value: '36-50' },
      { text: 'Over 50', value: 'Over 50' },
    ];
    if (authStore.isB2) {
      ages.unshift({ text: 'N/A', value: 'N/A' });
    }
    return ages;
  });


return (_ctx: any,_cache: any) => {
  const _component_AppFormGroupItem = _resolveComponent("AppFormGroupItem")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_AppCountrySelector = _resolveComponent("AppCountrySelector")!
  const _component_AppAddressAutoComplete = _resolveComponent("AppAddressAutoComplete")!
  const _component_b_form_checkbox = _resolveComponent("b-form-checkbox")!
  const _component_AppLoadingButton = _resolveComponent("AppLoadingButton")!
  const _component_b_form = _resolveComponent("b-form")!

  return (_openBlock(), _createBlock(_component_b_form, {
    class: _normalizeClass(["signup-component", { isSignup: isSignup }]),
    onSubmit: _withModifiers(handleSubmit, ["stop","prevent"])
  }, {
    default: _withCtx(() => [
      _createVNode(_component_AppFormGroupItem, {
        config: {
        label: '姓（＊全角で入力してください）',
        type: 'input',
        required: true,
        key: 'profile_attributes.last_name',
        placeholder: '例)田中'
      },
        form: _unref(form),
        onChange: handleFormItemChange
      }, null, 8, ["config", "form"]),
      _createVNode(_component_AppFormGroupItem, {
        config: {
        label: '名（＊全角で入力してください）',
        type: 'input',
        required: true,
        key: 'profile_attributes.first_name',
        placeholder: '例)太郎'
      },
        form: _unref(form),
        onChange: handleFormItemChange
      }, null, 8, ["config", "form"]),
      _createVNode(_component_AppFormGroupItem, {
        config: {
        label: '個人が特定されないユーザー名を設定してください',
        type: 'input',
        key: 'profile_attributes.nick_name',
        required: true,
        placeholder: '例）タロウ',
      },
        form: _unref(form),
        onChange: handleFormItemChange
      }, {
        description: _withCtx(() => [
          _hoisted_1,
          _createVNode(_component_router_link, {
            target: "_blank",
            to: { name: 'staticPage', params: { slug: 'privacy_policy' } }
          }, {
            default: _withCtx(() => [
              _hoisted_2
            ]),
            _: 1
          }),
          _hoisted_3
        ]),
        _: 1
      }, 8, ["config", "form"]),
      _hoisted_4,
      _hoisted_5,
      _hoisted_6,
      isSignup
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createVNode(_component_AppFormGroupItem, {
              config: {
          label: _unref(t)('EMAIL ADDRESS'),
          type: 'input',
          inputType: 'email',
          key: 'email',
          required: true,
          placeholder: 'address@domain.com'
        },
              form: _unref(form),
              onChange: handleFormItemChange
            }, null, 8, ["config", "form"]),
            _createVNode(_component_AppFormGroupItem, {
              config: {
          label: _unref(t)('PASSWORD'),
          type: 'input',
          inputType: 'password',
          key: 'password',
          required: true,
          placeholder: '',
          triggerPwd: true
        },
              form: _unref(form),
              onChange: handleFormItemChange
            }, null, 8, ["config", "form"]),
            _createVNode(_component_AppFormGroupItem, {
              config: {
          label: _unref(t)('CONFIRM PASSWORD'),
          type: 'input',
          inputType: 'password',
          key: 'password_confirmation',
          required: true,
          placeholder: '',
          triggerPwd: true
        },
              form: _unref(form),
              onChange: handleFormItemChange
            }, null, 8, ["config", "form"])
          ], 64))
        : _createCommentVNode("", true),
      _createVNode(_component_AppFormGroupItem, {
        config: {
        label: '団体の種類',
        type: 'select',
        key: 'profile_attributes.organization_type',
        required: true,
        options: _unref(_).map(_unref(settingStore).data.org_type_list, item => ({ text: item, value: item })),
      },
        form: _unref(form),
        onChange: handleFormItemChange
      }, null, 8, ["config", "form"]),
      _createVNode(_component_AppFormGroupItem, {
        config: {
        label: '団体名',
        type: 'input',
        key: 'profile_attributes.organization_name',
        required: false,
        placeholder: '団体名'
      },
        form: _unref(form),
        onChange: handleFormItemChange
      }, null, 8, ["config", "form"]),
      _createVNode(_component_AppFormGroupItem, {
        config: {
        label: _unref(t)('PHONE NUMBER FORM LABEL'),
        type: 'input',
        key: 'phone_number',
        inputType: 'tel',
        required: true,
        placeholder: '09012345678',
      },
        form: _unref(form),
        onChange: handleFormItemChange
      }, {
        inputBefore: _withCtx(() => [
          _createVNode(_component_AppCountrySelector, {
            "country-code": contryCode.value || _unref(locale),
            onExcountry: handleGetPhoneNumberCountry
          }, null, 8, ["country-code"])
        ]),
        _: 1
      }, 8, ["config", "form"]),
      _createVNode(_component_AppFormGroupItem, {
        config: {
        label: 'どこでテラサイクルを知りましたか?',
        type: 'select',
        key: 'profile_attributes.source_channel',
        required: false,
        options: [
          { text: '友人', value: '友人' },
          { text: '検索', value: '検索' },
          { text: 'ウェブサイト', value: 'ウェブサイト' },
          { text: 'イベント', value: 'イベント' },
          { text: 'ニュース', value: 'ニュース' },
          { text: 'シティリビング', value: 'シティリビング' },
        ],
      },
        form: _unref(form),
        onChange: handleFormItemChange
      }, null, 8, ["config", "form"]),
      _createVNode(_component_AppAddressAutoComplete, {
        "model-value": postalCode.value,
        onComplete: handleGetAddress
      }, null, 8, ["model-value"]),
      _createVNode(_component_AppFormGroupItem, {
        "class-name": "form-group-item-postal-code",
        config: {
        label: '郵便番号（ハイフンなし、半角英数字で入力してください）',
        type: 'input',
        key: 'profile_attributes.postal_code',
        required: true,
        placeholder: '事業所の個別郵便番号ではなく、集荷可能な郵便番号をご入力ください',
      },
        form: _unref(form),
        onChange: handleFormItemChange,
        onInput: handleAddressChange
      }, null, 8, ["config", "form"]),
      _createVNode(_component_AppFormGroupItem, {
        config: {
        label: '都道府県 （＊全角で入力してください）',
        type: 'input',
        key: 'profile_attributes.region',
        required: true,
        placeholder: '選択してください',
      },
        form: _unref(form),
        onChange: handleFormItemChange
      }, null, 8, ["config", "form"]),
      _createVNode(_component_AppFormGroupItem, {
        config: {
        label: '市区町村 （＊全角で入力してください）',
        type: 'input',
        key: 'profile_attributes.locality',
        required: true,
        placeholder: 'ｘｘ区',
      },
        form: _unref(form),
        onChange: handleFormItemChange
      }, null, 8, ["config", "form"]),
      _createVNode(_component_AppFormGroupItem, {
        config: {
        label: '市区町村以降（＊全角で入力してください',
        type: 'input',
        key: 'profile_attributes.street_address',
        required: true,
        placeholder: '例) ｘｘ１−１−１',
      },
        form: _unref(form),
        onChange: handleFormItemChange
      }, null, 8, ["config", "form"]),
      _createVNode(_component_AppFormGroupItem, {
        config: {
        label: 'マンション・建物名（＊全角で入力してください）',
        type: 'input',
        key: 'profile_attributes.extended_address',
        required: false,
        placeholder: '例）ｘｘビル１０１',
      },
        form: _unref(form),
        onChange: handleFormItemChange
      }, null, 8, ["config", "form"]),
      _createVNode(_component_AppFormGroupItem, {
        config: {
        label: '年齢',
        type: 'select',
        key: 'profile_attributes.age',
        required: true,
        options: _unref(ageOptions)
      },
        form: _unref(form),
        onChange: handleFormItemChange
      }, null, 8, ["config", "form"]),
      _createVNode(_component_AppFormGroupItem, {
        config: {
        label: '性別',
        type: 'radio',
        key: 'profile_attributes.gender',
        required: true,
        options: _unref(_).map(_unref(GENDER_MAP), (text, value) => ({ text, value })),
      },
        form: _unref(form),
        onChange: handleFormItemChange
      }, null, 8, ["config", "form"]),
      _createVNode(_component_AppFormGroupItem, {
        config: {
        label: '回収参加人数',
        type: 'input',
        inputType: 'number',
        min: 1,
        pattern: '[0-9]*',
        key: 'profile_attributes.people_collection',
        required: false,
        placeholder: '5'
      },
        form: _unref(form),
        onChange: handleFormItemChange
      }, null, 8, ["config", "form"]),
      isSignup
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_b_form_checkbox, {
                modelValue: _unref(agreeCheckbox).agree1,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(agreeCheckbox).agree1) = $event)),
                value: true,
                required: "",
                name: "agree1"
              }, {
                default: _withCtx(() => [
                  _hoisted_8,
                  _hoisted_9
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createVNode(_component_b_form_checkbox, {
                modelValue: _unref(agreeCheckbox).agree2,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(agreeCheckbox).agree2) = $event)),
                value: true,
                required: "",
                name: "agree2"
              }, {
                default: _withCtx(() => [
                  _hoisted_11,
                  _createVNode(_component_router_link, {
                    target: "_blank",
                    to: { name: 'staticPage', params: { slug: 'service_terms_and_conditions' } }
                  }, {
                    default: _withCtx(() => [
                      _hoisted_12
                    ]),
                    _: 1
                  }),
                  _hoisted_13,
                  _createVNode(_component_router_link, {
                    target: "_blank",
                    to: { name: 'staticPage', params: { slug: 'privacy_policy' } }
                  }, {
                    default: _withCtx(() => [
                      _hoisted_14
                    ]),
                    _: 1
                  }),
                  _hoisted_15,
                  _hoisted_16
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_17, [
              _createVNode(_component_b_form_checkbox, {
                modelValue: _unref(form).subscribe_tc_information,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(form).subscribe_tc_information) = $event)),
                value: true
              }, {
                default: _withCtx(() => [
                  _hoisted_18
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(signupAdditionalAgreements), (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                class: "form-item-agreement"
              }, [
                _createVNode(_component_b_form_checkbox, {
                  modelValue: _unref(signupCondictions)[index],
                  "onUpdate:modelValue": ($event: any) => ((_unref(signupCondictions)[index]) = $event),
                  value: item,
                  "unchecked-value": false
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(item), 1)
                  ]),
                  _: 2
                }, 1032, ["modelValue", "onUpdate:modelValue", "value"])
              ]))
            }), 128))
          ], 64))
        : _createCommentVNode("", true),
      _createVNode(_component_AppLoadingButton, {
        type: "submit",
        pill: "",
        variant: _unref(ColorVariants).primary,
        class: "btn-submit"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(isSignup ? 'サインアップ' : '保存'), 1)
        ]),
        _: 1
      }, 8, ["variant"])
    ]),
    _: 1
  }, 8, ["class", "onSubmit"]))
}
}

})